export enum errorMessageKey {
  ORGHASCHILDREN = "ORGHASCHILDREN",
  ORGNOTCREATED = "ORGNOTCREATED",
  ORGNOTCREATED_CODE = "ORGNOTCREATED_CODE",
  ORGNOTUPDATED = "ORGNOTUPDATED",
  ORGNOTUPDATED_CODE = "ORGNOTUPDATED_CODE",
  USEREMAILNOTUNIQUE = "USEREMAILNOTUNIQUE",
  GROUPNAMENOTUNIQUE = "GROUPNAMENOTUNIQUE",
  COLLECTIONALLREADYSHARED = "COLLECTIONALLREADYSHARED",
  COLLECTIONUSEDINAUTOPROCESSOPERATION = "COLLECTIONUSEDINAUTOPROCESSOPERATION",
  CANDIDATEALREADYINVITED = "CANDIDATEALREADYINVITED",
  PRIVACYPOLICYNOTACCEPTED = "PRIVACYPOLICYNOTACCEPTED",
  CANDIDATENOTSUPPORTEDSOURCE = "CANDIDATENOTSUPPORTEDSOURCE",
  CANDIDATENOAGENCY = "CANDIDATENOAGENCY",
  CANDIDATENOBIRTHDATE = "CANDIDATENOBIRTHDATE",
  CANDIDATENOCOUNTRYOFORIGIN = "CANDIDATENOCOUNTRYOFORIGIN",
  COLLECTIONRUNNINGPROCESSES = "COLLECTIONRUNNINGPROCESSES",
  COLLECTION_NAME_INVALID_CHARACTERS = "COLLECTION_NAME_INVALID_CHARACTERS",
  CANDIDATEPROFESSIONNOTSUPPORTED = "CANDIDATEPROFESSIONNOTSUPPORTED",
  GROUPRUNNINGPROCESSES = "GROUPRUNNINGPROCESSES",
  ORGRUNNINGPROCESSES = "ORGRUNNINGPROCESSES",
  ORGSHAREDCOLLECTIONS = "ORGSHAREDCOLLECTIONS",
  SHARINGRUNNINGPROCESSES = "SHARINGRUNNINGPROCESSES",
  PROCESSDUPLICATEIDS = "PROCESSDUPLICATEIDS",
  PROCESSMISSINGPREDECESSORS = "PROCESSMISSINGPREDECESSORS",
  PROCESSMISSINGATLEASTONEPREDECESSORS = "PROCESSMISSINGATLEASTONEPREDECESSORS",
  PROCESSMODELPREDECESSORCYCLE = "PROCESSMODELPREDECESSORCYCLE",
  PROCESSLISTTASKPREDECESSORNOTLISTTASK = "PROCESSLISTTASKPREDECESSORNOTLISTTASK",
  PROCESSMISSINGATTACHMENTTASKS = "PROCESSMISSINGATTACHMENTTASKS",
  PROCESSMISSINGREACTIVATETASKS = "PROCESSMISSINGREACTIVATETASKS",
  PROCESSMISSINGPREFILLTASK = "PROCESSMISSINGPREFILLTASK",
  PROCESSUNSUPPORTEDFILETYPES = "PROCESSUNSUPPORTEDFILETYPES",
  PROCESSMISSINGROLES = "PROCESSMISSINGROLES",
  PROCESSMISSINGANYROLES = "PROCESSMISSINGANYROLES",
  PROCESSATLEASTONEVISIBILEFORROLE = "PROCESSATLEASTONEVISIBILEFORROLE",
  PROCESSDUPLICATEMODELID = "PROCESSDUPLICATEMODELID",
  PROCESSEMPTDISPLAYNAME = "PROCESSEMPTDISPLAYNAME",
  PROCESSNOTWELLFORMEDDISPLAYDESCRIPTION = "PROCESSNOTWELLFORMEDDISPLAYDESCRIPTION",
  PROCESSEMPTYATTACHMENTDISPLAYNAME = "PROCESSEMPTYATTACHMENTDISPLAYNAME",
  PROCESSEMPTYPROCESSDOCUMENTDISPLAYNAME = "PROCESSEMPTYPROCESSDOCUMENTDISPLAYNAME",
  PROCESSMISSINGDOCUMENTTEMPLATE = "PROCESSMISSINGDOCUMENTTEMPLATE",
  PROCESSTEMPLATESNOTSPECIFIED = "PROCESSTEMPLATESNOTSPECIFIED",
  PROCESSMISSINGDOCUMENT = "PROCESSMISSINGDOCUMENT",
  PROCESSMISSINGDOCUMENTSET = "PROCESSMISSINGDOCUMENTSET",
  PROCESSMISSINGEMAILTEMPLATE = "PROCESSMISSINGEMAILTEMPLATE",
  PROCESSMISSINGEMAILTEMPLATELANGUAGE = "PROCESSMISSINGEMAILTEMPLATELANGUAGE",
  PROCESSTASKEMAILROLEFILTERMISMATCH = "PROCESSTASKEMAILROLEFILTERMISMATCH",
  PROCESSBADTEMPLATE = "PROCESSBADTEMPLATE",
  PROCESSWRONGCONVERSIONTYPE = "PROCESSWRONGCONVERSIONTYPE",
  PROCESSMISSINGMODELNAME = "PROCESSMISSINGMODELNAME",
  PROCESSMISSINGROLENAME = "PROCESSMISSINGROLENAME",
  PROCESSMISSINGDOCUMENTNAME = "PROCESSMISSINGDOCUMENTNAME",
  PROCESSMISSINGTASKDURATIONS = "PROCESSMISSINGTASKDURATIONS",
  PROCESSIDNOTWELLFORMED = "PROCESSIDNOTWELLFORMED",
  PROCESSIDCONTAINSFORBIDDENCHARACTERS = "PROCESSIDCONTAINSFORBIDDENCHARACTERS",
  PROCESSROLENAMENOTWELLFORMED = "PROCESSROLENAMENOTWELLFORMED",
  PROCESSDELEGATIONOPERATIONONPARENTTASKINVALID = "PROCESSDELEGATIONOPERATIONONPARENTTASKINVALID",
  PROCESSDELETIONNOTALLOWED = "PROCESSDELETIONNOTALLOWED",
  PROCESSMODELISNOTVALID = "PROCESSMODELISNOTVALID",
  PROCESSFINISHLABELISMISSING = "PROCESSFINISHLABELISMISSING",
  PROCESSMODELISEMPTY = "PROCESSMODELISEMPTY",
  AREAMODELISEMPTY = "AREAMODELISEMPTY",
  PHASEMODELISEMPTY = "PHASEMODELISEMPTY",
  ORGLINKED = "ORGLINKED",
  ORGALREADYLINKED = "ORGALREADYLINKED",
  ORGLICENSED = "ORGLICENSED",
  ORGUNLICENSED = "ORGUNLICENSED",
  FILEMALFORMED = "FILEMALFORMED",
  FILEEMPTY = "FILEEMPTY",
  FILEMISSINGEMAIL = "FILEMISSINGEMAIL",
  FILEINVALIDEMAIL = "FILEINVALIDEMAIL",
  FILEDUPLICATEEMAIL = "FILEDUPLICATEEMAIL",
  FILEEXISTINGEMAIL = "FILEEXISTINGEMAIL",
  FILEMISSINGFIRSTNAME = "FILEMISSINGFIRSTNAME",
  FILEMISSINGLASTNAME = "FILEMISSINGLASTNAME",
  FILEMISSINGSALUTATION = "FILEMISSINGSALUTATION",
  FILEMISSINGBIRTHDATE = "FILEMISSINGBIRTHDATE",
  FILEMISSINGCITYOFBIRTH = "FILEMISSINGCITYOFBIRTH",
  FILEMISSINGCOUNTRYOFBIRTH = "FILEMISSINGCOUNTRYOFBIRTH",
  FILEMISSINGCITIZENSHIP = "FILEMISSINGCITIZENSHIP",
  FILEMISSINGADDRESS = "FILEMISSINGADDRESS",
  FILEMISSINGCOUNTRYOFORIGIN = "FILEMISSINGCOUNTRYOFORIGIN",
  FILEMISSINGPHONE = "FILEMISSINGPHONE",
  FILEMISSINGMARTIALSTATUS = "FILEMISSINGMARTIALSTATUS",
  FILEMISSINGRECOGNOTICEFEDERALSTATE = "FILEMISSINGRECOGNOTICEFEDERALSTATE",
  FILEMISSINGREUNIFICATION = "FILEMISSINGREUNIFICATION",
  FILEMISSINGFIELDS = "FILEMISSINGFIELDS",
  DOCUMENTLOCKED = "DOCUMENTLOCKED",
  DOCUMENTUNLOCKINGERROR = "DOCUMENTUNLOCKINGERROR",
  DOCUMENTUNLOCKINGERROR2 = "DOCUMENTUNLOCKINGERROR2",
  DOCUMENTWRONGLOCKMODE = "DOCUMENTWRONGLOCKMODE",
  PROCESSACTIVATIONOVERFLOW = "PROCESSACTIVATIONOVERFLOW",
  COLLECTIONNAMENOTUNIQUE = "COLLECTIONNAMENOTUNIQUE",
  PROCESSNAMENOTUNIQUE = "PROCESSNAMENOTUNIQUE",
  ADHOCPROCESSALREADYEXISTS = "ADHOCPROCESSALREADYEXISTS",
  FILEMISSINGQUALIFICATION = "FILEMISSINGQUALIFICATION",
  CANDIDATEPROFILECONFIGALREADYEXISTS = "CANDIDATEPROFILECONFIGALREADYEXISTS",
  CANDIDATEPROFILECONFIGOWNDATATABSNOTALLOWED = "CANDIDATEPROFILECONFIGOWNDATATABSNOTALLOWED",
  LOCALPARTNERPROFILECONFIGALREADYEXISTS = "LOCALPARTNERPROFILECONFIGALREADYEXISTS",
  LOCALPARTNERPROFILECONFIGINUSE = "LOCALPARTNERPROFILECONFIGINUSE",
  UNEXPECTEDCANDIDATEROLE = "UNEXPECTEDCANDIDATEROLE",
  ACTIVATIONCONDITIONERROR = "ACTIVATIONCONDITIONERROR",
  RULERUNCONDITIONERROR = "RULERUNCONDITIONERROR",
  RULEEXPRESSIONERROR = "RULEEXPRESSIONERROR",
  TASKEMAILCONDITIONERROR = "TASKEMAILCONDITIONERROR",
  CANDIDATEPROFILEEXPRESSIONERROR = "CANDIDATEPROFILEEXPRESSIONERROR",
  REMINDEREMAILTEMPLATENOTFOUND = "REMINDEREMAILTEMPLATENOTFOUND",
  CANDIDATEREMINDEREMAILTEMPLATENOTFOUND = "CANDIDATEREMINDEREMAILTEMPLATENOTFOUND",
  ESCALATIONEMAILTEMPLATENOTFOUND = "ESCALATIONEMAILTEMPLATENOTFOUND",
  DEMOALREADYLICENSED = "DEMOALREADYLICENSED",
  EMAILTEMPLATENAMEALREADYEXISTS = "EMAILTEMPLATENAMEALREADYEXISTS",
  EMAILTEMPLATEHTMLNOTWELLFORMED = "EMAILTEMPLATEHTMLNOTWELLFORMED",
  EMAILTEMPLATESUBJECTNOTWELLFORMED = "EMAILTEMPLATESUBJECTNOTWELLFORMED",
  EMAILTEMPLATEISREQUIRED = "EMAILTEMPLATEISREQUIRED",
  EMAILTEMPLATENOTFOUND = "EMAILTEMPLATENOTFOUND",
  REQUIREDOCUMENTNAMEALREADYEXISTS = "REQUIREDOCUMENTNAMEALREADYEXISTS",
  REQUIREDDOCUMENTSREQUIRED = "REQUIREDDOCUMENTSREQUIRED",
  RULEMISSINGTARGET = "RULEMISSINGTARGET",
  RULEMISSINGPROPERTYNAME = "RULEMISSINGPROPERTYNAME",
  RULEEVENTNOTSUPPORTED = "RULEEVENTNOTSUPPORTED",
  RULETARGETIDSNOTSUPPORTED = "RULETARGETIDSNOTSUPPORTED",
  RULEMISSINGTARGETTASKS = "RULEMISSINGTARGETTASKS",
  RULETARGETTASKIDSNOTSUPPORTED = "RULETARGETTASKIDSNOTSUPPORTED",
  RULEMISSINGTARGETTASKIDS = "RULEMISSINGTARGETTASKIDS",
  RULEMISSINGTARGETPHASEIDS = "RULEMISSINGTARGETPHASEIDS",
  RULETARGETPHASEIDSNOTSUPPORTED = "RULETARGETPHASEIDSNOTSUPPORTED",
  RULEMISSINGTARGETAREAIDS = "RULEMISSINGTARGETAREAIDS",
  RULETARGETAREIDSNOTSUPPORTED = "RULETARGETAREIDSNOTSUPPORTED",
  RULEINVALIDTASKID = "RULEINVALIDTASKID",
  RULEINVALIDTARGETID = "RULEINVALIDTARGETID",
  FILEINVALIDPROFESSION = "FILEINVALIDPROFESSION",
  DROPPEDOUTFORBIDDEN = "DROPPEDOUTFORBIDDEN",
  PROCESSMODELNOTFOUND = "PROCESSMODELNOTFOUND",
  PROCESSMODELOFWRONGTYPE = "PROCESSMODELOFWRONGTYPE",
  PROCESSMODELCONTAINSERRORS = "PROCESSMODELCONTAINSERRORS",
  PROCESSMODELIMPORTMODELMISSING = "PROCESSMODELIMPORTMODELMISSING",
  PROCESSMODELEXCLUDEIDNOTFOUND = "PROCESSMODELEXCLUDEIDNOTFOUND",
  PROCESSMODELINSERTAREAIDEXISTS = "PROCESSMODELINSERTAREAIDEXISTS",
  PROCESSMODELINSERTPHASEIDEXISTS = "PROCESSMODELINSERTPHASEIDEXISTS",
  PROCESSMODELINSERTTASKIDEXISTS = "PROCESSMODELINSERTTASKIDEXISTS",
  PROCESSMODELREPLACEAREAIDNOTFOUND = "PROCESSMODELREPLACEAREAIDNOTFOUND",
  PROCESSMODELREPLACEPHASEIDNOTFOUND = "PROCESSMODELREPLACEPHASEIDNOTFOUND",
  PROCESSMODELREPLACETASKIDNOTFOUND = "PROCESSMODELREPLACETASKIDNOTFOUND",
  PROCESSMODELINUSE = "PROCESSMODELINUSE",
  UNDEFINEDCANDIDATEPROPERTY = "UNDEFINEDCANDIDATEPROPERTY",
  RELEASEDPROCESSMODELINUSE = "RELEASEDPROCESSMODELINUSE",
  RELEASEDPROCESSMODELISPUBLISHED = "RELEASEDPROCESSMODELISPUBLISHED",
  RELEASEDPROCESSMODELNOTFOUND = "RELEASEDPROCESSMODELNOTFOUND",
  CANDIDATEEMAILNOTUNIQUE = "CANDIDATEEMAILNOTUNIQUE",
  DOCUMENTNAMENOTUNIQUE = "DOCUMENTNAMENOTUNIQUE",
  DOCUMENTTEMPLATEISREQUIRED = "DOCUMENTTEMPLATEISREQUIRED",
  PROCESSMODELNOTAVAILABLE = "PROCESSMODELNOTAVAILABLE",
  PROCESSRELEASESELECTIONMODENOTSUPPORTED = "PROCESSRELEASESELECTIONMODENOTSUPPORTED",
  PROCESSTESTMODEREQUIRESPROCESSADMIN = "PROCESSTESTMODEREQUIRESPROCESSADMIN",
  PROCESSTESTPROCESSCANNOTBEDELEGATED = "PROCESSTESTPROCESSCANNOTBEDELEGATED",
  PROCESSCANNOTBECOMETESTPROCESS = "PROCESSCANNOTBECOMETESTPROCESS",
  PROCESSTASKPREVIEWCANDIDATENOTINCOLLECTION = "PROCESSTASKPREVIEWCANDIDATENOTINCOLLECTION",
  PROCESSTASKPREVIEWCANDIDATERESTRICTED = "PROCESSTASKPREVIEWCANDIDATERESTRICTED",
  SHARINGCONFIGURATIONCHANGED = "SHARINGCONFIGURATIONCHANGED",
  SHARINGISNOTCOLLABORATION = "SHARINGISNOTCOLLABORATION",
  SHARINGNOTVALID = "SHARINGNOTVALID",
  INTERNALMASKCONFIGURATIONCHANGED = "INTERNALMASKCONFIGURATIONCHANGED",
  INTERNALMASKCONFIGURATIONREQUIRED = "INTERNALMASKCONFIGURATIONREQUIRED",
  IMMIGRATIONCOUNTRYCHANGENOTALLOWED = "IMMIGRATIONCOUNTRYCHANGENOTALLOWED",
  CANDIDATEMISSINGFIELDS = "CANDIDATEMISSINGFIELDS",
  SHARINGNNOTSUPPORTEDITECANDIDATE = "SHARINGNNOTSUPPORTEDITECANDIDATE",
  ORGUSEDASSOURCEORLANGSCHOOL = "ORGUSEDASSOURCEORLANGSCHOOL",
  DOCUMENTSALREADYUPLOADED = "DOCUMENTSALREADYUPLOADED",
  DOCUMENTMERGEUNSUPPORTEDFILE = "DOCUMENTMERGEUNSUPPORTEDFILE",
  DOCUMENTMERGEONLYUPLOADEDFILES = "DOCUMENTMERGEONLYUPLOADEDFILES",
  NOTARIZATIONSALREADYUPLOADED = "NOTARIZATIONSALREADYUPLOADED",
  TRANSLATIONSALREADYUPLOADED = "TRANSLATIONSALREADYUPLOADED",
  TASKDELETED = "TASKDELETED",
  TASKDELETIONNOTALLOWED = "TASKDELETIONNOTALLOWED",
  MATCHINGENABLED = "MATCHINGENABLED",
  PARTICIPATION_CONDITION_PROCESS_CREATE = "PARTICIPATION_CONDITION_PROCESS_CREATE",
  PARTICIPATION_CONDITION_PROCESS_SYNC = "PARTICIPATION_CONDITION_PROCESS_SYNC",
  PARTICIPATION_CONDITION_PROCESS_SYNC_ALL = "PARTICIPATION_CONDITION_PROCESS_SYNC_ALL",
  PARTICIPATION_CONDITION_PROCESS_COLLECTION_CHANGE = "PARTICIPATION_CONDITION_PROCESS_COLLECTION_CHANGE",
  PARTICIPATION_CONDITION_CANDIDATE_ADD = "PARTICIPATION_CONDITION_CANDIDATE_ADD",
  PARTICIPATION_CONDITION_CANDIDATE_UPDATE = "PARTICIPATION_CONDITION_CANDIDATE_UPDATE",
  USEREXISTASCANDIDATE = "USEREXISTASCANDIDATE",
  NOFITTINGCVSEMPLATEAVAILABLE = "NOFITTINGCVSEMPLATEAVAILABLE",
  PROCESSINVALIDAUTOSTATECHANGESETTINGS = "PROCESSINVALIDAUTOSTATECHANGESETTINGS",
  LAYOUT_TEMPLATE_AT_LEAST_ONE_PLACEHOLDER = "LAYOUT_TEMPLATE_AT_LEAST_ONE_PLACEHOLDER",
  LAYOUT_TEMPLATE_MISSING_MARKERS = "LAYOUT_TEMPLATE_MISSING_MARKERS",
  LAYOUT_TEMPLATE_MISSING_MAIN_MARKER = "LAYOUT_TEMPLATE_MISSING_MAIN_MARKER",
  LAYOUT_TEMPLATE_UNIQUE_MARKERS = "LAYOUT_TEMPLATE_UNIQUE_MARKERS",
  CONTENT_TEMPLATE_AT_LEAST_ONE_NODE = "CONTENT_TEMPLATE_AT_LEAST_ONE_NODE",
  CONTENT_TEMPLATE_MISSING_MAIN_MARKER = "CONTENT_TEMPLATE_MISSING_MAIN_MARKER",
  TEMPLATE_OR_COLLECTION_NOT_FOUND = "TEMPLATE_OR_COLLECTION_NOT_FOUND",
  TEMPLATE_AND_COLLECTION_MISMATCH = "TEMPLATE_AND_COLLECTION_MISMATCH",
  TEMPLATE_AND_COLLECTION_VARIABLE_MISMATCH = "TEMPLATE_AND_COLLECTION_VARIABLE_MISMATCH",
  PROCESS_OPERATION_PROCESS_MODEL_MISMATCH = "PROCESS_OPERATION_PROCESS_MODEL_MISMATCH",
  PROCESS_OPERATION_INVALID_COLLECTION = "PROCESS_OPERATION_INVALID_COLLECTION",
  SYNC_ALL_WITH_TEMPLATE_FAILED = "SYNC_ALL_WITH_TEMPLATE_FAILED",
  SYNC_WITH_TEMPLATE_FAILED = "SYNC_WITH_TEMPLATE_FAILED",
  TEMPLATE_VARIABLES_CHANGED = "TEMPLATE_VARIABLES_CHANGED",
  TEMPLATE_USED_IN_PROCESSES = "TEMPLATE_USED_IN_PROCESSES",
  TEMPLATE_USED_IN_ACTIONS = "TEMPLATE_USED_IN_ACTIONS",
  COLLECTION_USED_IN_ACTIONS = "COLLECTION_USED_IN_ACTIONS",
  CANDIDATE_NOT_FOUND = "CANDIDATE_NOT_FOUND",
  COLLECTION_NOT_FOUND = "COLLECTION_NOT_FOUND",
  USER_NOT_FOUND = "USER_NOT_FOUND",
  TASK_NOT_FOUND = "TASK_NOT_FOUND",
  ORGANIZATION_NOT_FOUND = "ORGANIZATION_NOT_FOUND",
  DOCUMENT_NOT_FOUND = "DOCUMENT_NOT_FOUND",
  PROCESS_NOT_FOUND = "PROCESS_NOT_FOUND",
  TEMPLATE_NAME_NOT_UNIQUE = "TEMPLATE_NAME_NOT_UNIQUE",
  COLLECTION_COULD_NOT_BE_MAPPED = "COLLECTION_COULD_NOT_BE_MAPPED",
  ATTACH_PROCESS_INVALID_ACTION_ID = "ATTACH_PROCESS_INVALID_ACTION_ID",
  ATTACH_PROCESS_INVALID_OPERATION_ID = "ATTACH_PROCESS_INVALID_OPERATION_ID",
  ATTACH_PROCESS_INVALID_PROCESS_ID = "ATTACH_PROCESS_INVALID_PROCESS_ID",
  ATTACH_PROCESS_INVALID_OPERATION = "ATTACH_PROCESS_INVALID_OPERATION",
  DETACH_PROCESS_INVALID_ACTION_ID = "DETACH_PROCESS_INVALID_ACTION_ID",
  DETACH_PROCESS_INVALID_PROCESS_ID = "DETACH_PROCESS_INVALID_PROCESS_ID",
  DETACH_PROCESS_INVALID_OPERATION_ID = "DETACH_PROCESS_INVALID_OPERATION_ID",
  EDUCATION_EXAM_RESULTS_EXIST = "EDUCATION_EXAM_RESULTS_EXIST",
  ORGANIZATIONDOCUMENTISREQUIRED = "ORGANIZATIONDOCUMENTISREQUIRED",
  TALENT_POOL_NAME_NOT_UNIQUE = "TALENT_POOL_NAME_NOT_UNIQUE",
  TALENT_POOL_PARTICIPANTS_NOT_UNIQUE = "TALENT_POOL_PARTICIPANTS_NOT_UNIQUE",
  TALENT_POOL_PARTICIPANTS_NOT_ALLOWED_FOR_WEBSITE_POOL = "TALENT_POOL_PARTICIPANTS_NOT_ALLOWED_FOR_WEBSITE_POOL",
  TALENT_POOL_CONTRIBUTOR_NOT_LICENSED = "TALENT_POOL_CONTRIBUTOR_NOT_LICENSED",
  TALENT_POOL_SHARING_NOT_UNIQUE = "TALENT_POOL_SHARING_NOT_UNIQUE",
  FEATURENOTAVAILABLE = "FEATURENOTAVAILABLE",
  PROCESSDELEGATIONLOOP = "PROCESSDELEGATIONLOOP",
  CANDIDATES_FROM_DIFFERENT_ORGANIZATIONS = "CANDIDATES_FROM_DIFFERENT_ORGANIZATIONS",
  NOREPLY_REQUIRES_ADDITIONAL_OPTIONS = "NOREPLY_REQUIRES_ADDITIONAL_OPTIONS",
  SHARING_PRESET_NAME_NOT_UNIQUE = "SHARING_PRESET_NAME_NOT_UNIQUE",
  SHARING_PRESET_IN_USE_TALENT_POOL = "SHARING_PRESET_IN_USE_TALENT_POOL",
  TRANSLATION_FAILED = "TRANSLATION_FAILED",
  TEMPLATE_OUTDATED = "TEMPLATE_OUTDATED",
  CANT_MODIFY_TASK = "CANT_MODIFY_TASK",
  DOCUMENT_USED_IN_PENDING_TRANSLATION = "DOCUMENT_USED_IN_PENDING_TRANSLATION",
  FILE_USED_IN_PENDING_TRANSLATION = "FILE_USED_IN_PENDING_TRANSLATION",
  DOCUMENT_USED_IN_ACTIVE_SIGNING_SUBMISSION = "DOCUMENT_USED_IN_ACTIVE_SIGNING_SUBMISSION",
  CANDIDATECOMPETENCIESNOTVALID = "CANDIDATECOMPETENCIESNOTVALID",
  PROCESS_MILESTONE_DEFINITION_INCOMPLETE = "PROCESS_MILESTONE_DEFINITION_INCOMPLETE",
  PROCESS_MILESTONE_DEFINITION_OVERLAPS = "PROCESS_MILESTONE_DEFINITION_OVERLAPS",
  //--------Errors specific for the InterviewWrite task---------
  PROCESS_MISSING_PREDECESSORS = "PROCESS_MISSING_PREDECESSORS",
  PROCESS_INVALID_TASK_TYPE = "PROCESS_INVALID_TASK_TYPE",
  PROCESS_INVALID_FORM_TOKEN = "PROCESS_INVALID_FORM_TOKEN",
  PROCESS_INVALID_REPLY_TYPE = "PROCESS_INVALID_REPLY_TYPE",
  PROCESS_INVALID_TARGET_ROLE = "PROCESS_INVALID_TARGET_ROLE",
  //--------Errors specific for the Signing task----------------
  PROCESS_SIGNING_NO_TEMPLATES_SELECTED = "PROCESS_SIGNING_NO_TEMPLATES_SELECTED",
  PROCESS_SIGNING_SIGNER_ORDER_INCOMPLETE = "PROCESS_SIGNING_SIGNER_ORDER_INCOMPLETE",
  PROCESS_SIGNING_INVALID_SKIPPABLE_TEMPLATES = "PROCESS_SIGNING_INVALID_SKIPPABLE_TEMPLATES",
  PROCESS_SIGNING_DUPLICATE_TEMPLATE_NAMES = "PROCESS_SIGNING_DUPLICATE_TEMPLATE_NAMES",
  PROCESS_SIGNING_INVALID_TEMPLATE_NAME = "PROCESS_SIGNING_INVALID_TEMPLATE_NAME",
  PROCESS_SIGNING_DUPLICATE_ROLE_MAPPING = "PROCESS_SIGNING_DUPLICATE_ROLE_MAPPING",
  PROCESS_SIGNING_CANDIDATE_ROLE_MAPPED = "PROCESS_SIGNING_CANDIDATE_ROLE_MAPPED",
  PROCESS_SIGNING_INVALID_PROCESS_ROLE = "PROCESS_SIGNING_INVALID_PROCESS_ROLE",
  PROCESS_SIGNING_LIST_TARGET_NOT_SUPPORTED = "PROCESS_SIGNING_LIST_TARGET_NOT_SUPPORTED",
  PROCESS_SIGNING_ROLE_ORGANIZATION_CONFLICT = "PROCESS_SIGNING_ROLE_ORGANIZATION_CONFLICT",
  PROCESS_SIGNING_UNUSABLE_TEMPLATE_ROLES = "PROCESS_SIGNING_UNUSABLE_TEMPLATE_ROLES",
  PROCESS_SIGNING_TEMPLATE_NOT_ENABLED = "PROCESS_SIGNING_TEMPLATE_NOT_ENABLED",
  DOCUMENT_SIGNING_ADDON_NOT_ENABLED = "DOCUMENT_SIGNING_ADDON_NOT_ENABLED",
  //------------------------------------------------------------
  TASK_TYPE_ADDON_NOT_ENABLED = "TASK_TYPE_ADDON_NOT_ENABLED",
  PROCESS_RESET_NOT_SUPPORTED = "PROCESS_RESET_NOT_SUPPORTED",
  PROCESS_RESET_PROCESS_INACTIVE = "PROCESS_RESET_PROCESS_INACTIVE",
  MISSING_CONTRACT = "MISSING_CONTRACT",
  SHARING_PRESET_NOT_A_TALENT_POOL_PRESET = "SHARING_PRESET_NOT_A_TALENT_POOL_PRESET",
  AUTOTEAMNOTEDITABLE = "AUTOTEAMNOTEDITABLE",
  AI_PII_DETECTED = "AI_PII_DETECTED",
  AI_RATE_LIMIT_EXCEEDED = "AI_RATE_LIMIT_EXCEEDED",
  AI_PROCESS_AGENT_NOT_LICENSED = "AI_PROCESS_AGENT_NOT_LICENSED",
  AI_PROCESS_AGENT_SESSION_EXPIRED = "AI_PROCESS_AGENT_SESSION_EXPIRED",
  AI_PROCESS_AGENT_UNAVAILABLE = "AI_PROCESS_AGENT_UNAVAILABLE",
  SINGLETEAMNOTEDITABLE = "SINGLETEAMNOTEDITABLE",
  CV_PARSING_NOT_ENABLED = "CV_PARSING_NOT_ENABLED",
  CV_PARSING_BUDGET_EXCEEDED = "CV_PARSING_BUDGET_EXCEEDED",
  CV_PARSING_FILE_TOO_LARGE = "CV_PARSING_FILE_TOO_LARGE",
  CV_PARSING_UNSUPPORTED_DOCUMENT = "CV_PARSING_UNSUPPORTED_DOCUMENT",
  CV_PARSING_UNSUPPORTED_LANGUAGE = "CV_PARSING_UNSUPPORTED_LANGUAGE",
  ORGLINKINVITATIONNOTFOUND = "ORGLINKINVITATIONNOTFOUND",
  ORGLINKINVITATIONINVALID = "ORGLINKINVITATIONINVALID",
  ORGLINKINVITATIONEXPIRED = "ORGLINKINVITATIONEXPIRED",
  ORGLINKINVITATIONALREADYUSED = "ORGLINKINVITATIONALREADYUSED",
  ORGLINKINVITATIONSELF = "ORGLINKINVITATIONSELF",
  ORGLINKINVITATIONTARGETNOTFOUND = "ORGLINKINVITATIONTARGETNOTFOUND",
  ORGLINKINVITATIONTARGETUNLICENSED = "ORGLINKINVITATIONTARGETUNLICENSED",
  ORGLINKINVITATIONWRONGORGANIZATION = "ORGLINKINVITATIONWRONGORGANIZATION",
  LOOKBACK_DAYS_OUT_OF_RANGE = "LOOKBACK_DAYS_OUT_OF_RANGE",
  INTERVIEW_MULTI_EDIT_EMPLOYER_NOT_ALLOWED = "INTERVIEW_MULTI_EDIT_EMPLOYER_NOT_ALLOWED",
  INTERVIEW_MULTI_EDIT_DATE_REQUIRED = "INTERVIEW_MULTI_EDIT_DATE_REQUIRED",
  LIST_MULTI_EDIT_BATCH_NOT_FOUND = "LIST_MULTI_EDIT_BATCH_NOT_FOUND",
  LIST_MULTI_EDIT_LIST_NOT_SUPPORTED = "LIST_MULTI_EDIT_LIST_NOT_SUPPORTED",
  LIST_MULTI_EDIT_INVALID_ELEMENT = "LIST_MULTI_EDIT_INVALID_ELEMENT",
  OUTBOXEMAILNOTPENDING = "OUTBOXEMAILNOTPENDING",
  EMAILNOTRESENDABLE = "EMAILNOTRESENDABLE",
  EMAILRESENDTESTPROCESS = "EMAILRESENDTESTPROCESS",
  OUTBOXDISPATCHRUNNING = "OUTBOXDISPATCHRUNNING",
  EMAILRESENDRUNNING = "EMAILRESENDRUNNING",
  TASK_DELEGATION_RULE_SELF_REFERENCE = "TASK_DELEGATION_RULE_SELF_REFERENCE",
  TASK_DELEGATION_RULE_OWN_ORGANIZATION_SOURCE = "TASK_DELEGATION_RULE_OWN_ORGANIZATION_SOURCE",
  TASK_DELEGATION_RULE_OWN_ORGANIZATION_TARGET = "TASK_DELEGATION_RULE_OWN_ORGANIZATION_TARGET",
  TASK_DELEGATION_RULE_TARGET_NOT_FOUND = "TASK_DELEGATION_RULE_TARGET_NOT_FOUND",
  TASK_DELEGATION_RULE_TARGET_BLOCKED = "TASK_DELEGATION_RULE_TARGET_BLOCKED",
  TASK_DELEGATION_RULE_ENTRY_AFTER_CATCH_ALL = "TASK_DELEGATION_RULE_ENTRY_AFTER_CATCH_ALL",
  TASK_DELEGATION_RULE_NOT_UNIQUE = "TASK_DELEGATION_RULE_NOT_UNIQUE",
  TASK_DELEGATION_RULE_ALL_NOT_UNIQUE = "TASK_DELEGATION_RULE_ALL_NOT_UNIQUE",
  TASK_DELEGATION_RULE_SOURCE_NOT_LINKED = "TASK_DELEGATION_RULE_SOURCE_NOT_LINKED",
  TASK_DELEGATION_RULE_TARGET_NOT_LINKED = "TASK_DELEGATION_RULE_TARGET_NOT_LINKED",
  TASK_DELEGATION_RULE_NOT_FOUND = "TASK_DELEGATION_RULE_NOT_FOUND",
  TASK_DELEGATION_RULES_PAUSED = "TASK_DELEGATION_RULES_PAUSED",
  TASK_CANDIDATE_SELECTION_NOT_SUPPORTED = "TASK_CANDIDATE_SELECTION_NOT_SUPPORTED",
  PROCESS_MODEL_COPY_SOURCE_NOT_AVAILABLE = "PROCESS_MODEL_COPY_SOURCE_NOT_AVAILABLE",
  PROCESS_MODEL_COMMAND_BATCH_INVALID = "PROCESS_MODEL_COMMAND_BATCH_INVALID",
  PROCESS_MODEL_COMMAND_BATCH_MODEL_IDS_INVALID = "PROCESS_MODEL_COMMAND_BATCH_MODEL_IDS_INVALID",
  PROCESS_MODEL_COMMAND_ID_TAKEN = "PROCESS_MODEL_COMMAND_ID_TAKEN",
  TRANSLATION_ORDER_ALREADY_CANCELLED = "TRANSLATION_ORDER_ALREADY_CANCELLED",
}
